import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./animations.css";

// Clear invalid authentication tokens before app starts
// import "./utils/auth-cleanup.ts";

createRoot(document.getElementById("root")!).render(<App />);
